import React from 'react';
import PurchaseInvoiceForm from './PurchaseInvoiceForm'; // Adjust path
import { useParams } from 'react-router-dom';

const EditPurchaseInvoicePage = () => {
    const { id } = useParams();
    // Fetch and pass data, handle loading state
    return id ? <PurchaseInvoiceForm formType="edit" currentInvoiceId={id} /> : <div>Loading...</div>;
};
export default EditPurchaseInvoicePage;